import { render, staticRenderFns } from "./thread.vue?vue&type=template&id=aca5d0cc&"
import script from "./thread.vue?vue&type=script&lang=js&"
export * from "./thread.vue?vue&type=script&lang=js&"
import style0 from "./thread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports